import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { SERVICES } from "../../data/services";
import { SERVICES as SVC_IDS } from "../../constants/testIds";

export function ServicesGrid() {
	return (
		<section id="services" className="py-16 md:py-24 bg-slate-50 dark:bg-slate-950/40">
			<div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
				<div className="max-w-2xl">
					<p className="text-xs font-bold uppercase tracking-[0.2em] text-emerald-600 dark:text-emerald-400">What we do</p>
					<h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold text-slate-900 dark:text-white">
						Everything your school needs to grow
					</h2>
					<p className="mt-4 text-lg text-slate-600 dark:text-slate-300">
						Eight focused services — from filling seats to launching new campuses.
					</p>
				</div>

				<div data-testid={SVC_IDS.grid} className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-4">
					{SERVICES.map((s, i) => (
						<motion.div
							key={s.id}
							initial={{ opacity: 0, y: 20 }}
							whileInView={{ opacity: 1, y: 0 }}
							viewport={{ once: true }}
							transition={{ delay: (i % 4) * 0.06 }}
						>
							<Link
								to={`/services/${s.id}`}
								data-testid={SVC_IDS.card(s.id)}
								className="group flex flex-col h-full rounded-2xl border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-900 p-6 hover:border-emerald-400 dark:hover:border-emerald-500 hover:shadow-xl hover:shadow-emerald-600/5 hover:-translate-y-1 transition-all"
							>
								<div className="flex items-center justify-between">
									<span className="grid place-items-center h-11 w-11 rounded-xl bg-emerald-500/10 text-emerald-600 dark:text-emerald-400">
										<s.icon className="h-5 w-5" />
									</span>
									<ArrowUpRight className="h-4 w-4 text-slate-300 group-hover:text-emerald-500 transition-colors" />
								</div>
								<span className="mt-4 inline-block w-fit rounded-full bg-amber-500/10 border border-amber-500/20 px-2.5 py-0.5 text-[11px] font-semibold text-amber-700 dark:text-amber-300">
									{s.badge}
								</span>
								<h3 className="mt-3 font-heading text-lg font-semibold text-slate-900 dark:text-white">{s.title}</h3>
								<p className="mt-2 text-sm text-slate-600 dark:text-slate-400 leading-relaxed flex-1">{s.desc}</p>
							</Link>
						</motion.div>
					))}
				</div>
			</div>
		</section>
	);
}
